/** Technologies for marketing site — grouped for modern stack showcase */
export const techCategories = [
  {
    id: 'frontend',
    label: 'Web & UI',
    description: 'Fast, animated interfaces',
    items: [
      { name: 'React', icon: 'fab fa-react', color: '#61DAFB' },
      { name: 'Next.js', icon: 'fas fa-layer-group', color: '#0f172a' },
      { name: 'JavaScript', icon: 'fab fa-js', color: '#F7DF1E' },
      { name: 'TypeScript', icon: 'fas fa-code', color: '#3178C6' },
      { name: 'HTML5', icon: 'fab fa-html5', color: '#E34F26' },
      { name: 'CSS3', icon: 'fab fa-css3-alt', color: '#1572B6' },
      { name: 'Tailwind', icon: 'fas fa-wind', color: '#06B6D4' },
      { name: 'Framer Motion', icon: 'fas fa-film', color: '#0e6b3c' },
    ],
  },
  {
    id: 'backend',
    label: 'Backend & APIs',
    description: 'Scalable server logic',
    items: [
      { name: 'Node.js', icon: 'fab fa-node-js', color: '#339933' },
      { name: 'Laravel', icon: 'fab fa-laravel', color: '#FF2D20' },
      { name: 'PHP', icon: 'fab fa-php', color: '#777BB4' },
      { name: 'REST API', icon: 'fas fa-plug', color: '#0e6b3c' },
      { name: 'JWT', icon: 'fas fa-shield-alt', color: '#6dbb1a' },
      { name: 'MySQL', icon: 'fas fa-database', color: '#4479A1' },
      { name: 'MongoDB', icon: 'fas fa-leaf', color: '#47A248' },
      { name: 'Redis', icon: 'fas fa-bolt', color: '#DC382D' },
    ],
  },
  {
    id: 'cms',
    label: 'E-commerce & CMS',
    description: 'Stores & content sites',
    items: [
      { name: 'WordPress', icon: 'fab fa-wordpress', color: '#21759B' },
      { name: 'WooCommerce', icon: 'fas fa-shopping-cart', color: '#96588A' },
      { name: 'Shopify', icon: 'fab fa-shopify', color: '#96BF48' },
      { name: 'Elementor', icon: 'fas fa-palette', color: '#92003B' },
      { name: 'SEO', icon: 'fas fa-search', color: '#0e6b3c' },
    ],
  },
  {
    id: 'mobile',
    label: 'Mobile & Cloud',
    description: 'Apps & infrastructure',
    items: [
      { name: 'Flutter', icon: 'fas fa-mobile-alt', color: '#02569B' },
      { name: 'React Native', icon: 'fab fa-react', color: '#61DAFB' },
      { name: 'Firebase', icon: 'fas fa-fire', color: '#FFCA28' },
      { name: 'AWS', icon: 'fab fa-aws', color: '#FF9900' },
      { name: 'Docker', icon: 'fab fa-docker', color: '#2496ED' },
      { name: 'Git', icon: 'fab fa-git-alt', color: '#F05032' },
    ],
  },
];

export const techMarqueeItems = techCategories.flatMap((c) => c.items);
